import { render, staticRenderFns } from "./ProofSeal.vue?vue&type=template&id=868f037e&scoped=true&"
import script from "./ProofSeal.vue?vue&type=script&lang=js&"
export * from "./ProofSeal.vue?vue&type=script&lang=js&"
import style0 from "./ProofSeal.vue?vue&type=style&index=0&id=868f037e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868f037e",
  null
  
)

export default component.exports